@if (!isSingleDate) {
  <div class="date-time-input-wrapper">
    <mat-form-field>
      <input
        matInput
        placeholder="MM/DD/YYYY - MM/DD/YYYY"
        class="mat-date-range-input-inner pushInput"
        (click)="!disabled && (showPicker = true)"
        [value]="displayDateValue"
        [attr.data-pw]="`${dataPwPrefix}-date-input`"
        [attr.data-qa]="`${dataQaPrefix}-date-input`"
        readonly />

      <!-- Calendar icon inside border -->
      <button mat-icon-button matSuffix [disabled]="disabled" (click)="!disabled && (showPicker = true)">
        <mat-icon>date_range</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field>
      <input
        matInput
        placeholder="AM - PM"
        class="mat-date-range-input-inner pushInput"
        (click)="!disabled && (showPicker = true)"
        [value]="displayTimeValue"
        [attr.data-pw]="`${dataPwPrefix}-time-input`"
        [attr.data-qa]="`${dataQaPrefix}-time-input`"
        readonly />

      <!-- Calendar icon inside border -->
      <button mat-icon-button matSuffix [disabled]="disabled" (click)="!disabled && (showPicker = true)">
        <mat-icon>schedule</mat-icon>
      </button>
    </mat-form-field>
  </div>

  <!-- Date Range Picker Popup -->
  @if (showPicker) {
    <div class="picker-popup">
      <div class="range-picker-container" [class.disabled]="disabled">
        <div class="calendar-row">
          <!-- Start Date -->
          <mat-calendar
            #startCalendar
            class="range-calendar"
            [startAt]="leftCalendarMonth"
            (selectedChange)="onDateSelected($event)"
            [dateClass]="dateClass"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [attr.data-pw]="`${dataPwPrefix}-start-calendar`"
            [attr.data-qa]="`${dataQaPrefix}-start-calendar`">
          </mat-calendar>

          <!-- End Date -->
          <mat-calendar
            #endCalendar
            class="range-calendar"
            [startAt]="rightCalendarStart"
            [minDate]="minDate"
            [maxDate]="maxDate"
            (selectedChange)="onDateSelected($event)"
            [dateClass]="dateClass"
            [attr.data-pw]="`${dataPwPrefix}-end-calendar`"
            [attr.data-qa]="`${dataQaPrefix}-end-calendar`">
          </mat-calendar>
        </div>

        <!-- Time Selection -->
        <div class="time-row">
          <mat-form-field
            appearance="outline"
            [attr.data-pw]="`${dataPwPrefix}-start-time-input`"
            [attr.data-qa]="`${dataQaPrefix}-start-time-input`">
            <mat-select [(ngModel)]="startTime" placeholder="Start Time">
              @for (t of timeSlots; let i = $index; track t) {
                <mat-option [value]="t">{{ t }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field
            appearance="outline"
            [attr.data-pw]="`${dataPwPrefix}-end-time-input`"
            [attr.data-qa]="`${dataQaPrefix}-end-time-input`">
            <mat-select [(ngModel)]="endTime" placeholder="End Time">
              @for (t of timeSlots; let i = $index; track t) {
                <mat-option [value]="t">{{ t }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        @if (validationMessage) {
          <div
            class="validation-message"
            [attr.data-pw]="`${dataPwPrefix}-validation-message`"
            [attr.data-qa]="`${dataQaPrefix}-validation-message`">
            {{ validationMessage }}
          </div>
        }
        <!-- Actions -->
        <div class="action-row">
          <button mat-stroked-button (click)="cancel()" [disabled]="disabled">Cancel</button>
          <button mat-flat-button color="primary" (click)="applyDateAndTime()" [disabled]="disabled">Apply</button>
        </div>
      </div>
    </div>
  }
} @else {
  <div class="date-time-input-wrapper">
    <mat-form-field>
      <input
        matInput
        placeholder="MM/DD/YYYY"
        class="mat-date-range-input-inner pushInput"
        (click)="!disabled && (showPicker = true)"
        [value]="displayDateValue"
        [attr.data-pw]="`${dataPwPrefix}-date-input`"
        [attr.data-qa]="`${dataQaPrefix}-date-input`"
        readonly />

      <button mat-icon-button matSuffix [disabled]="disabled" (click)="!disabled && (showPicker = true)">
        <mat-icon>date_range</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field>
      <input
        matInput
        placeholder="Time"
        class="mat-date-range-input-inner pushInput"
        (click)="!disabled && (showPicker = true)"
        [value]="displayTimeValue"
        [attr.data-pw]="`${dataPwPrefix}-time-input`"
        [attr.data-qa]="`${dataQaPrefix}-time-input`"
        readonly />

      <button mat-icon-button matSuffix [disabled]="disabled" (click)="!disabled && (showPicker = true)">
        <mat-icon>schedule</mat-icon>
      </button>
    </mat-form-field>
  </div>

  @if (showPicker) {
    <div class="picker-popup">
      <div class="range-picker-container" [class.disabled]="disabled">
        <div class="calendar-row">
          <mat-calendar
            #startCalendar
            class="range-calendar"
            [selected]="startDateObj"
            [startAt]="leftCalendarMonth"
            (selectedChange)="onDateSelected($event)"
            [dateClass]="dateClass"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [attr.data-pw]="`${dataPwPrefix}-start-calendar`"
            [attr.data-qa]="`${dataQaPrefix}-start-calendar`">
          </mat-calendar>
        </div>

        <div class="time-row">
          <mat-form-field
            appearance="outline"
            [attr.data-pw]="`${dataPwPrefix}-start-time-input`"
            [attr.data-qa]="`${dataQaPrefix}-start-time-input`">
            <mat-select [(ngModel)]="startTime" placeholder="Time">
              @for (t of timeSlots; let i = $index; track t) {
                <mat-option [value]="t">{{ t }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        @if (validationMessage) {
          <div
            class="validation-message"
            [attr.data-pw]="`${dataPwPrefix}-validation-message`"
            [attr.data-qa]="`${dataQaPrefix}-validation-message`">
            {{ validationMessage }}
          </div>
        }
        <div class="action-row">
          <button mat-stroked-button (click)="cancel()" [disabled]="disabled">Cancel</button>
          <button mat-flat-button color="primary" (click)="applyDateAndTime()" [disabled]="disabled">Apply</button>
        </div>
      </div>
    </div>
  }
}
